import React, {useMemo, useState} from 'react';
import { useNavigate } from "react-router-dom";
import productCardIni from "../../../cookieStorage/productCardIni";
import ProductBasketOrder from "../Products/ProductElements/productBasketOrder";
import {makePayment} from "../../../reduxLib/paymentLib";
import {fetchVisitorByUUID} from "../../../reduxLib/visitorLib";
import {fetchSessionByVisitorRelID} from "../../../reduxLib/sessionLib";
import {useDispatch} from "react-redux";

function OrderPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const shopingCardList=productCardIni();
    const totalPrice = shopingCardList.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
    );
    // ---- totals (σωστά) ----
    const shippingFee = 8.0;
    const taxRate = 0.24;
    const subtotal = useMemo(() => {
        return shopingCardList.reduce((sum, item) => sum + (Number(item.price) || 0) * (Number(item.quantity) || 0), 0);
    }, [shopingCardList]);

    const tax = useMemo(() => subtotal * taxRate, [subtotal]);
    const total = useMemo(() => subtotal + tax + (shopingCardList.length ? shippingFee : 0), [subtotal, tax, shopingCardList.length]);


    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        street: "",
        apt: "",
        region: "",
        city: "",
        postalCode: "",
        country: "Greece",
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const setField = (key) => (e) => {
        setForm(prev => ({ ...prev, [key]: e.target.value }));
        setErrors(prev => ({ ...prev, [key]: undefined })); // καθάρισε error όταν γράφει
    };

    function validate() {
        const next = {};

        if (!shopingCardList.length) next.cart = "Το καλάθι είναι άδειο.";

        if (!form.firstName.trim()) next.firstName = "Υποχρεωτικό";
        if (!form.lastName.trim()) next.lastName = "Υποχρεωτικό";

        if (!form.email.trim()) next.email = "Υποχρεωτικό";
        else if (!/^\S+@\S+\.\S+$/.test(form.email.trim())) next.email = "Μη έγκυρο email";

        if (!form.phone.trim()) next.phone = "Υποχρεωτικό";
        if (!form.street.trim()) next.street = "Υποχρεωτικό";
        if (!form.city.trim()) next.city = "Υποχρεωτικό";
        if (!form.region.trim()) next.city = "Υποχρεωτικό";
        if (!form.postalCode.trim()) next.postalCode = "Υποχρεωτικό";

        setErrors(next);
        return Object.keys(next).length === 0;
    }

    // Φτιάχνεις order payload "μαζεμένα"
    function buildOrderPayload() {
        return {
            customer: {
                firstName: form.firstName.trim(),
                lastName: form.lastName.trim(),
                email: form.email.trim(),
                phone: form.phone.trim(),
            },
            shippingAddress: {
                street: form.street.trim(),
                apt: form.apt.trim() || null,
                city: form.city.trim(),
                postalCode: form.postalCode.trim(),
                country: form.country,
                region: form.region?.trim() || null,
            },
            pricing: {
                subtotal: Number(subtotal.toFixed(2)),
                taxRate,
                tax: Number(tax.toFixed(2)),
                shipping: shopingCardList.length ? shippingFee : 0,
                total: Number(total.toFixed(2)),
                currency: "EUR",
            },
            items: shopingCardList.map((p) => ({
                productId: p.productId ?? p.id ?? null, // βάλε εδώ το σωστό πεδίο σου
                name: p.name,
                unitPrice: Number(p.price) || 0,
                quantity: Number(p.quantity) || 0,
                image: p.image,
                // αν έχεις επιλογές:
                // colorId: p.colorId ?? null,
                // size: p.size ?? null,
                // textile: p.textile ?? null,
                // closing: p.closing ?? null,
            })),
            createdAt: new Date().toISOString(),
        };
    }

    async function orderCompletion() {
        if (!validate()) return;

        setIsSubmitting(true);
        try {
            const payload = buildOrderPayload();
            let vid = localStorage.getItem("vid");
            await dispatch(fetchVisitorByUUID(vid)).unwrap().then(visitor => {
                console.log("Visitor for order:", visitor);
                payload.visitorId = visitor.visitorID; // πρόσθεσε visitorId στο payload
            }).dispatch(fetchSessionByVisitorRelID(payload.visitorId)).unwrap().then(session => {
                console.log("Session for order:", session);
                payload.sessionId = session.sessionId; // πρόσθεσε sessionId στο payload
            })


            // TODO: βάλε το endpoint σου
            // const res = await fetch("https://api.rotheras.gr/orders", {
            //   method: "POST",
            //   headers: { "Content-Type": "application/json" },
            //   body: JSON.stringify(payload),
            //   credentials: "include", // αν χρειάζεσαι cookies/session
            // });

            // if (!res.ok) {
            //   const txt = await res.text().catch(() => "");
            //   throw new Error(txt || `Order failed (${res.status})`);
            // }

            // const data = await res.json();
            // εδώ: καθάρισε cart (ανάλογα πώς το κρατάς)
            // clearCart();
            // navigate(`/order/success/${data.orderId}`);

            const res=await dispatch(makePayment(payload)).then(
                r=>r.json()

            ).catch(e=>{
                console.error("Payment error", e);
                throw new Error("Payment failed");
            });

            navigate(`/checkout/success/rqerqwer`); // προσωρινά

            console.log("ORDER PAYLOAD", payload);

        } catch (e) {
            console.error(e);
            setErrors(prev => ({ ...prev, submit: e?.message || "Κάτι πήγε στραβά" }));
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleSubmit = (e) => {
        console.log("Submitting order...");
        e.preventDefault();
        orderCompletion();
        //orderCompletion().then(r => ()=>navigate(`checkout/success/rqerqwer`) );
       // navigate(`/checkout/success/rqerqwer`);
    }

    return (
        <div>
            <section id="page-header" className="bg-white py-12 border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="flex items-center space-x-3 text-sm text-gray-600 mb-4">
                        <a href="" onClick={()=>{navigate(`/products`)}} className="hover:text-custom-green transition-colors">Home</a>
                        <i className="fas fa-chevron-right text-xs"></i>
                        <a href="" onClick={()=>{navigate(`/shopingcard`)}} className="hover:text-custom-green transition-colors">Cart</a>
                        <i className="fas fa-chevron-right text-xs"></i>
                        <span className="text-custom-green font-medium">Checkout</span>
                    </div>
                    <h1 className="text-4xl font-print font-bold text-gray-800">Checkout</h1>
                    <p className="text-lg font-print text-gray-600 mt-2">Complete your order</p>
                </div>
            </section>
            <section id="checkout-content" className="py-16 bg-cream">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

                        <div id="checkout-form" className="space-y-8">
                            <div id="contact-info" className="bg-white rounded-xl shadow-sm p-8">
                                <h2 className="text-2xl font-print font-semibold text-gray-800 mb-6">Contact
                                    Information</h2>
                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-print font-medium text-gray-700 mb-2">First
                                                Name</label>
                                            <input
                                                type="text"
                                                value={form.firstName}
                                                onChange={setField("firstName")}
                                                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                            />
                                            {errors.firstName && <p className="text-xs text-red-600 mt-1">{errors.firstName}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-print font-medium text-gray-700 mb-2">Last
                                                Name</label>
                                            <input
                                                type="text"
                                                value={form.lastName}
                                                onChange={setField("lastName")}
                                                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                            />
                                            {errors.lastName && <p className="text-xs text-red-600 mt-1">{errors.lastName}</p>}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-print font-medium text-gray-700 mb-2">Email
                                            Address</label>
                                        <input
                                            type="email"
                                            value={form.email}
                                            onChange={setField("email")}
                                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                        />
                                        {errors.email && <p className="text-xs text-red-600 mt-1">{errors.email}</p>}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-print font-medium text-gray-700 mb-2">Phone
                                            Number</label>
                                        <input
                                            type="tel"
                                            value={form.phone}
                                            onChange={setField("phone")}
                                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                        />
                                        {errors.phone && <p className="text-xs text-red-600 mt-1">{errors.phone}</p>}
                                    </div>
                                </div>
                            </div>

                            <div id="shipping-address" className="bg-white rounded-xl shadow-sm p-8">
                                <h2 className="text-2xl font-print font-semibold text-gray-800 mb-6">Shipping
                                    Address</h2>
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-print font-medium text-gray-700 mb-2">Street
                                            Address</label>
                                        <input
                                            type="text"
                                            value={form.street}
                                            onChange={setField("street")}
                                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                        />
                                        {errors.street && <p className="text-xs text-red-600 mt-1">{errors.street}</p>}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-print font-medium text-gray-700 mb-2">Apartment,
                                            Suite, etc. (Optional)</label>
                                        <input
                                            type="text"
                                            value={form.apt}
                                            onChange={setField("apt")}
                                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                        />
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <div>
                                            <label className="block text-sm font-print font-medium text-gray-700 mb-2">City</label>
                                            <input
                                                type="text"
                                                value={form.city}
                                                onChange={setField("city")}
                                                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                            />
                                            {errors.city && <p className="text-xs text-red-600 mt-1">{errors.city}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-print font-medium text-gray-700 mb-2">Region</label>
                                            <input
                                                type="text"
                                                value={form.region}
                                                onChange={setField("city")}
                                                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                            />
                                            {errors.city && <p className="text-xs text-red-600 mt-1">{errors.region}</p>}
                                        </div>
                                        <div>
                                            <label className="block text-sm font-print font-medium text-gray-700 mb-2">Postal
                                                Code</label>
                                            <input
                                                type="text"
                                                value={form.postalCode}
                                                onChange={setField("postalCode")}
                                                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                            />
                                            {errors.postalCode && <p className="text-xs text-red-600 mt-1">{errors.postalCode}</p>}
                                        </div>
                                        <div>
                                            <label
                                                className="block text-sm font-print font-medium text-gray-700 mb-2">Country</label>
                                            <select
                                                value={form.country}
                                                onChange={setField("country")}
                                                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-custom-green transition-colors"
                                            >
                                                <option>Greece</option>
                                                <option>Cyprus</option>
                                                <option>Bulgaria</option>
                                                <option>Other EU</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>

                        <div id="order-summary" className="lg:sticky lg:top-24 h-fit">
                            <div className="bg-white rounded-xl shadow-sm p-8">
                                <h2 className="text-2xl font-print font-semibold text-gray-800 mb-6">Order Summary</h2>

                                <div id="order-items" className="space-y-4 mb-6">
                                    {
                                        shopingCardList.map((product)=>(
                                            <ProductBasketOrder
                                                name={product.name}
                                                image={product.image}
                                                quantity={product.quantity}
                                                price={product.price}
                                            />
                                        ))
                                    }
                                </div>


                                <div className="space-y-3 mb-6 pt-6 border-t border-gray-200">
                                    <div className="flex justify-between font-print text-gray-600">
                                        <span>Subtotal</span>
                                        <span className="font-medium">€{subtotal.toFixed(2)}</span>
                                    </div>
                                    <div className="flex justify-between font-print text-gray-600">
                                        <span>Shipping</span>
                                        <span className="font-medium">€{shopingCardList.length ? shippingFee.toFixed(2) : "0.00"}</span>
                                    </div>
                                    <div className="flex justify-between font-print text-gray-600">
                                        <span>Tax (24%)</span>
                                        <span className="font-medium">€{tax.toFixed(2)}</span>
                                    </div>
                                </div>

                                <div className="border-t border-gray-200 pt-4 mb-8">
                                    <div className="flex justify-between text-xl font-print font-bold text-gray-800">
                                        <span>Total</span>
                                        <span className="text-custom-green">€{total.toFixed(2)}</span>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    disabled={isSubmitting}
                                    className="w-full font-print bg-custom-green hover:bg-dark-green disabled:opacity-60 text-white py-4 rounded-lg font-semibold text-lg transition-colors duration-300 mb-4"
                                >
                                    {isSubmitting ? "Submitting..." : "Complete Order"}
                                </button>

                                <div
                                    className="flex font-print items-center justify-center space-x-2 text-sm text-gray-500 mb-6">
                                    <i className="fas fa-shield-alt"></i>
                                    <span>256-bit SSL Encryption</span>
                                </div>

                                <div className="pt-6 border-t border-gray-200">
                                    <h3 className="font-semibold font-print text-gray-800 mb-3">Accepted Payment
                                        Methods</h3>
                                    <div className="flex items-center space-x-3">
                                        <i className="fab fa-cc-visa text-3xl text-gray-400"></i>
                                        <i className="fab fa-cc-mastercard text-3xl text-gray-400"></i>
                                        <i className="fab fa-cc-amex text-3xl text-gray-400"></i>
                                        <i className="fab fa-cc-paypal text-3xl text-gray-400"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default OrderPage;